import { useEffect } from "react";
import classNames from "classnames";
import { uniqueId } from "lodash";
import { searchIcon } from "../../../../assets/icons";

const ChooseTemplate = ({
  templates,
  setSelectedTemplate,
  selectedTemplate,
  setFieldValue,
  values,
}) => {
  useEffect(() => {
    if (!selectedTemplate) return;
    setFieldValue("name", values.name);
    setFieldValue("cloudService", values.cloudService);
  }, [selectedTemplate, setFieldValue, values]);

  return (
    <>
      <div className="flex-1 flex overflow-auto">
        <div className="scrollbar h-100 w-72 p-2 overflow-auto border-r border-gray-700">
          <div className="search relative w-full mb-6">
            <div className="absolute top-1/2 -translate-y-1/2 left-3 ">
              <img src={searchIcon} width="20" alt="search" />
            </div>
            <input
              type="text"
              className="bg-gray-800 border w-full  !border-gray-700 rounded-md pl-11 text-gray-300 h-10"
              placeholder="Search"
            />
          </div>
          <ul className="space-y-1">
            {templates?.map((template) => (
              <li key={uniqueId()}>
                <button
                  type="button"
                  onClick={() => setSelectedTemplate(template)}
                  className={classNames(
                    "hover:bg-gray-900 text-gray-200 w-full text-left text-sm leading-8 py-2 px-4 rounded-lg",
                    {
                      "bg-gray-900":
                        selectedTemplate.templateKey === template.templateKey,
                    }
                  )}
                >
                  {template.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="scrollbar h-full flex-1 p-6 overflow-auto pt-1">
          <div className="flex flex-row justify-between">
            <div className="mb-8">
              <h6 className="text-lg text-gray-50 font-bold mb-1">
                {selectedTemplate.name}
              </h6>
              <p className="text-sm text-gray-50">
                {selectedTemplate.description}
              </p>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.open(selectedTemplate.previewURL, "_blank")}
            >
              Preview
            </button>
          </div>
          <div>
            <img
              src={selectedTemplate.previewGif}
              className="w-full rounded-md -mt-6"
              alt="template"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseTemplate;
